import {useFormContext} from 'react-hook-form'

import {mapVerticalToDeliveryType} from '../utils/map-vertical-to-delivery-type'

export function useVerticalType() {
  const verticalName = useFormContext().watch('vertical_name')

  return {
    rawVertical: verticalName,
    mappedVertical: mapVerticalToDeliveryType(verticalName),
  }
}
